import type { MqttContainer, MqttValue } from './types'
import { MqttTopic } from './topics'

export const cranksetPedalDifference: MqttValue = {
  title: 'pedal difference enabled',
  topic: MqttTopic.CRANKSET_PEDAL_DIFF,
  unit: '',
}

export const cranksetPedalRatio: MqttValue = {
  title: 'pedal ratio',
  topic: MqttTopic.CRANKSET_PEDAL_RATIO,
  unit: '%',
}

export const cranksetPedal: MqttContainer = {
  title: 'pedal',
  prefix: 'pedal_',
  values: [cranksetPedalDifference, cranksetPedalRatio],
}

export const cranksetTorqueLeft: MqttValue = {
  title: 'torque left',
  topic: MqttTopic.CRANKSET_LEFT_TORQUE,
  unit: 'Nm',
  decimalPlaces: 1,
}

export const cranksetTorqueRight: MqttValue = {
  title: 'torque right',
  topic: MqttTopic.CRANKSET_RIGHT_TORQUE,
  unit: 'Nm',
  decimalPlaces: 1,
}

export const cranksetTorque: MqttContainer = {
  title: 'torque',
  prefix: '',
  values: [cranksetTorqueLeft, cranksetTorqueRight],
}

export const cranksetSmoothnessLeft: MqttValue = {
  title: 'smoothness left',
  topic: MqttTopic.CRANKSET_LEFT_SMOOTHNESS,
  unit: '%',
}

export const cranksetSmoothnessRight: MqttValue = {
  title: 'smoothness right',
  topic: MqttTopic.CRANKSET_RIGHT_SMOOTHNESS,
  unit: '%',
}

export const cranksetSmoothness: MqttContainer = {
  title: 'smoothness',
  prefix: '',
  values: [cranksetSmoothnessLeft, cranksetSmoothnessRight],
}

export const cranksetCadence: MqttValue = {
  title: 'cadence',
  topic: MqttTopic.CRANKSET_CADENCE,
  unit: 'RPM',
}

export const cranksetAccumulatedPower: MqttValue = {
  title: 'accumulated power',
  unit: 'W',
  topic: MqttTopic.CRANKSET_ACCUMULATED_POWER,
}

export const cranksetInstantaneousPower: MqttValue = {
  title: 'power',
  unit: 'W',
  topic: MqttTopic.CRANKSET_INSTANTANEOUS_POWER,
}

export const cranksetDefinitions: MqttContainer = {
  title: 'Crankset',
  prefix: 'crankset/',
  values: [
    cranksetPedal,
    cranksetCadence,
    cranksetAccumulatedPower,
    cranksetInstantaneousPower,
    cranksetTorqueLeft,
    cranksetTorqueRight,
    cranksetSmoothness,
  ],
}

export default cranksetDefinitions
